import { PlaceHolder } from "@/services/smsPlaceHolders/type";
import { Alert, Badge, Group, Stack, Text, Anchor } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import { Link } from "react-router-dom";

interface EmptyPreviewTagsAlertProps {
  emptyTags: PlaceHolder[];
}

export const EmptyPreviewTagsAlert = ({
  emptyTags,
}: EmptyPreviewTagsAlertProps) => {
  if (emptyTags.length === 0) return null;

  return (
    <Alert color="red">
      <Stack gap="xs">
        <Text size="xs" c="red" dir="rtl">
          مقدار توسط شما وارد نشده است
        </Text>
        <Text size="xs" dir="rtl">
          برخی از تگ‌های پیام شما مقدار لازم برای ارسال را ندارند. لطفا مقادیر
          زیر را تکمیل کنید:
        </Text>
        <Group mt="xs" gap="xs" wrap="wrap" dir="rtl">
          {emptyTags.map((tag) => (
            <Badge key={tag.key} color="red" style={{ margin: "0 2px" }}>
              {tag.value}
            </Badge>
          ))}
        </Group>
        <Group justify="flex-end" dir="rtl">
          <Anchor component={Link} to="/dashboard/profile/edit">
            <Group gap="5">
              <Text size="xs" td="underline">
                کامل کردن اطلاعات
              </Text>
              <IconChevronLeft size={15} />
            </Group>
          </Anchor>
        </Group>
      </Stack>
    </Alert>
  );
};
